import { Typography } from '@material-ui/core'
import { useMemo } from 'react'

import Button from '@/components/button'
import InputText from '@/components/input-text'
import { useCreatePulverizationMap } from '@/pages/diagnosis-view/contexts/create-pulverization-map-context'
import {
  EquipmentDefinitionFormProvider,
  EquipmentFormValue,
  useEquipmentDefinitionForm,
} from '@/pages/diagnosis-view/contexts/equipment-definition-form'

import { InputItem } from './input-item'
import { useStyles } from './styles'

function EquipmentDefinitionComponent() {
  const classes = useStyles()

  const {
    handleSubmit,
    formState: { errors },
    register,
  } = useEquipmentDefinitionForm()

  const {
    infestationData,
    previousStep,
    processDemandResumeMutation: { isLoading, mutate },
  } = useCreatePulverizationMap()

  const filteredLayersMap = useMemo(
    () =>
      infestationData?.layersMap.filter(
        (layer) => !layer.removed && !layer.mergedName,
      ),
    [infestationData?.layersMap],
  )

  function onSubmit(data: EquipmentFormValue) {
    mutate(data)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={classes.container}>
      <div className={classes.root}>
        <header>
          <Typography variant='h3'>
            Definir equipamento e vazão para aplicação
          </Typography>
        </header>
        <ul>
          {infestationData?.mergedLayersMap.map((layer) => (
            <InputItem
              key={layer.name}
              from='mergedLayersMap'
              name={layer.name}
              bgColor={layer.colorPalette}
              border='1px solid #00000033'
            />
          ))}

          {filteredLayersMap?.map((layer) => (
            <InputItem
              key={layer.name}
              from='layersMap'
              name={layer.name}
              bgColor={layer.colorPalette}
            />
          ))}
        </ul>
      </div>

      <Typography component='label' className={classes.dateLabel}>
        Previsão para pulverização
      </Typography>

      <div className={classes.dateContainer}>
        <InputText
          id='pulverization_date_start'
          type={'date'}
          required
          label={'Data inicial'}
          InputLabelProps={{ shrink: true }}
          error={!!errors.pulverization_date?.start_date}
          helperText={errors.pulverization_date?.start_date?.message}
          onKeyDown={(e) => e.preventDefault()}
          {...register('pulverization_date.start_date')}
        />
        <InputText
          id='pulverization_date_end'
          type={'date'}
          label={'Data final'}
          InputLabelProps={{ shrink: true }}
          error={!!errors.pulverization_date?.end_date}
          helperText={errors.pulverization_date?.end_date?.message}
          onKeyDown={(e) => e.preventDefault()}
          {...register('pulverization_date.end_date')}
        />
      </div>

      <div className={classes.buttonContainer}>
        <Button outlined onClick={previousStep}>
          Voltar
        </Button>
        <Button
          type='submit'
          loading={isLoading}
          disabled={infestationData?.layersMap.every((layer) => layer.removed)}
        >
          Avançar
        </Button>
      </div>
    </form>
  )
}

export function EquipmentDefinition() {
  return (
    <EquipmentDefinitionFormProvider>
      <EquipmentDefinitionComponent />
    </EquipmentDefinitionFormProvider>
  )
}
